import { getApiRequest } from 'api';
import { EducationalPlan } from 'types/educationalPlan';

export const getAllEducationalPlans = (): Promise<EducationalPlan[]> => {
    return getApiRequest('/educational-plan/');
};
